import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, UsersIcon, CheckSquareIcon } from 'lucide-react';
const bonuses = [{
  icon: <FileTextIcon className="w-8 h-8 text-gold" data-id="element-12" />,
  title: 'Plantillas de Contratos Profesionales',
  desc: 'Modelos listos para usar y adaptar, redactados con los más altos estándares legales.',
  value: '$9.990'
}, {
  icon: <UsersIcon className="w-8 h-8 text-gold" data-id="element-13" />,
  title: 'Guía de Captación de Clientes para Abogados',
  desc: 'Estrategias probadas para atraer clientes de calidad sin parecer desesperado.',
  value: '$7.990'
}, {
  icon: <CheckSquareIcon className="w-8 h-8 text-gold" data-id="element-14" />,
  title: 'Checklist de Gestión de Expedientes',
  desc: 'El paso a paso exacto para que ningún plazo o trámite se te pase por alto.',
  value: '$5.990'
}];
export function BonusesSection() {
  return <section className="bg-navy-dark py-16 md:py-24 px-4 relative" data-id="element-15">
      {/* Background accent */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/5 via-navy-dark to-navy-dark pointer-events-none" data-id="element-16"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-18">
          <div className="inline-block bg-red-600 text-white font-bold px-6 py-2 rounded-full mb-6 animate-pulse" data-id="element-19">
            ⚠️ ATENCIÓN
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-20">
            🎁 BONOS EXCLUSIVOS —{' '}
            <span className="text-gold" data-id="element-21">¡GRATIS POR EL DÍA DE HOY!</span>
          </h2>
          <p className="text-xl text-gray-300" data-id="element-22">
            Llevate todo este material adicional sin costo extra si ordenás hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-light p-6 md:p-8 rounded-2xl border border-gold/30 flex flex-col h-full" data-id="element-24">
              <div className="flex items-center gap-4 mb-4" data-id="element-25">
                <div className="bg-navy-dark p-3 rounded-xl border border-gold/20" data-id="element-26">
                  {bonus.icon}
                </div>
                <h3 className="text-xl font-bold text-white" data-id="element-27">{bonus.title}</h3>
              </div>
              <p className="text-gray-400 mb-6 flex-grow" data-id="element-28">{bonus.desc}</p>
              <div className="mt-auto pt-4 border-t border-gray-800 flex justify-between items-center" data-id="element-29">
                <span className="text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-30">
                  Valor normal:
                </span>
                <span className="text-red-400 line-through font-bold" data-id="element-31">
                  {bonus.value}
                </span>
                <span className="text-green-400 font-black ml-2" data-id="element-32">
                  ¡HOY GRATIS!
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}